export const environment = {
  production: true,
  authServer: 'https://gw.federicosecondo.riatlas.it/authorization',
  resourceServer: 'https://gw.federicosecondo.riatlas.it/resource',
  fhirServer: 'https://gw.federicosecondo.riatlas.it/fhir',
  elastic: 'https://gw.federicosecondo.riatlas.it/resource',
  mobile: 'https://gw.federicosecondo.riatlas.it/mobile',
  company: 'Riatlas.it',
  baseHref: 'cloud'
};
